// extracted by mini-css-extract-plugin
module.exports = {"container":"DefaultLayout_container__kQqL3","content":"DefaultLayout_content__2vYlZ"};